import { redirect } from "@tanstack/react-router";
import { createMiddleware } from "@tanstack/react-start";
import { getAuthSession } from "#/modules/util.auth/session.auth.server";
import { getLocaleOnServer } from "#/modules/util.i18n/get-locale.server";

export const lockedLessonGuard = createMiddleware({ type: "function" }).server(async ({ next }) => {
  const session = await getAuthSession();
  const lockedLes = session.data.lockedLes;
  if (!lockedLes) {
    return next();
  }

  throw redirect({
    to: "/$locale/{-$schoolyear}/$school/lesson/$lesson/student",
    params: { locale: getLocaleOnServer(), school: lockedLes.schoolSlug, lesson: lockedLes.lesId },
  });
});
